import React from 'react'
import ReactDOM from 'react-dom'
import InspirationBlock from './components/InspirationBlock'
import InspirationPage from './components/InspirationPage';
import { TranslationContext } from '../common/Translation';
import store from './store';
import { Provider } from 'react-redux';

export const InspirationContext = React.createContext({})

const { searchData: { locale = 'fr', translations = {} } = {} } = window

const blockElement = document.querySelector('div[data-react-inspiration="block"]')
const resultElement = document.querySelector('div[data-react-inspiration="result"]')

if (blockElement) {
  ReactDOM.render(
    <Provider store={store}>
      <TranslationContext.Provider value={{locale, translationRegistry: translations}}>
        <InspirationBlock />
      </TranslationContext.Provider>
    </Provider>,
    document.querySelector('div[data-react-inspiration="block"]')
  )
}

if (resultElement) {
  ReactDOM.render(
    <Provider store={store}>
      <TranslationContext.Provider value={{locale, translationRegistry: translations}}>
        <InspirationPage />
      </TranslationContext.Provider>
    </Provider>,
    document.querySelector('div[data-react-inspiration="result"]')
  )
}
